import { PhysicalAttackSkill, StatusSkill } from "../../core/skill";
import { ConsumeEffect, Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

export const 银雾之翼 = new PhysicalAttackSkill(
    "银雾之翼",
    type.王,
    [
        "消除对手的回合类效果，消除成功则使对手下1回合先制-2",
        "消除对手的能力提升，消除成功则使对手下1回合先制-2",
        "若以上2项均消除成功，则吸取对手最大体力的1/3",
        "若打出致命一击则获得2层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，否则获得1层",
    ],
    80,
    [
        new Effect(new effect.消除强化(), Timing.onDamage),
        new Effect(new effect.消除回合(), Timing.onDamage),
        new Effect(new effect.根据暴击获得神耀能量(), Timing.onDamage),
    ],
    3,
    false,
    10,
    5,
);

export const 挚金命轮 = new StatusSkill(
    "挚金命轮",
    [
        "使对手全属性-1，对手处于能力提升状态时弱化效果翻倍",
        "命中后有70%的几率使对手失明，未触发则1回合内对手属性技能无效",
        "3回合内，若对手使用属性技能则减少对手所有技能2点pp值",
        "3回合内，若对手使用攻击技能则立即减少其最大体力的1/3",
    ],
    [
        new Effect(new effect.弱化(1), Timing.onSkillHit),
        new Effect(new effect.弱化(1), Timing.onSkillHit, cond.若对手处于强化状态),
    ],
    0,
    5,
);

export const 黎羽幻生 = new StatusSkill(
    "黎羽幻生",
    [
        "全属性+1，自身不处于能力提升状态时强化效果翻倍",
        "恢复自身最大体力的1/1并造成等量的百分比伤害",
        "获得2层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>",
        "下2回合自身所有技能先制+2，并且直接攻击必定致命一击",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若自身不处于强化状态),
            Timing.onSkillHit,
        ),
        new Effect(
            new effect.回血·固伤(pred.自身最大体力的x分之一(1)),
            Timing.onSkillHit,
        ),
        new Effect(new effect.获得x层神耀能量(2), Timing.onSkillHit),
        new RoundEffect(Timing.onSkillHit, 2, new effect.先制(2), Timing.battleStageBegin).nextRound(),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
    0,
    5,
);

export const 无上天命剑 = new PhysicalAttackSkill(
    "无上天命剑",
    type.王,
    [
        "无视对手的攻击免疫效果",
        "附加与对手上1次造成攻击伤害等量的固定伤害",
        "2回合内若击败对手，则击败对手后可保留2层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>",
    ],
    150,
    [
        new Effect(new effect.击败后保留x层神耀能量(2, 2), Timing.onSkillHit),
        new Effect(new effect.无视攻击免疫(), Timing.beforeSkillHit),
    ],
    0,
    false,
    1,
    5,
);

export const 正义天启歌 = new PhysicalAttackSkill(
    "正义天启歌",
    type.王,
    [
        "无视对手的伤害限制效果",
        "自身每储存1层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，则此技能威力提升50点",
        "后出手时，免疫下1回合受到的攻击",
    ],
    170,
    [
        new Effect(new effect.每层神耀能量增加技能威力x点(50), Timing.beforeDamage),
        new RoundEffect(
            Timing.onSkillHit,
            1,
            new effect.免疫攻击(),
            Timing.beforeSkillHit,
            undefined,
            false,
            [],
            cond.若后出手,
        ).nextRound(),
    ],
    0,
    true,
    1,
    5,
);
